export const CODE_SUCCESS = '0'
export const INITIAL_STATE = {
  instance: null,
  hasRequestedInitialization: false,
  isStandalone: true,
}
export const MAX_FIND_DEPTH = 50
